/**
 * Handing an artifact to the browser, through the session.
 *
 * The bytes are fetched with the API client - which carries the session cookie
 * and makes the server re-check ownership - and passed to the browser as a
 * blob URL revoked immediately afterwards. There is deliberately **no** direct
 * link to the endpoint: an `<a href>` into the API would be a URL that can be
 * copied out of the page, and a storage key or a path must never appear in the
 * document at all.
 *
 * Extracted when the model screen gained its own download, so the outputs
 * table and the viewer cannot drift into two different delivery mechanisms -
 * one of which would eventually be the convenient, unauthenticated one.
 */

import { getArtifactContent } from "@/api/client";
import { ApiError } from "@/api/errors";

export async function downloadArtifact(
  jobId: string,
  artifactId: string,
  /** Built from the artifact's kind and format, never from a server path. */
  filename: string,
): Promise<void> {
  const buffer = await getArtifactContent(jobId, artifactId);
  const url = URL.createObjectURL(new Blob([buffer]));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

/** What to tell somebody whose download did not happen. */
export function downloadFailureText(error: unknown): string {
  return error instanceof ApiError && error.status === 404
    ? "Bu çıktı artık mevcut değil."
    : "Dosya indirilemedi. Lütfen tekrar deneyin.";
}
